import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { dismissNotification } from "../../redux/actions/notification";
import { SUCCESS_GREEN, WARNING_YELLOW, ERROR_RED } from "../../constants/colors";

const ToastContainer = styled.div`
  position: fixed;
  top: 80px;
  right: 20px;
  z-index: 9999;
  max-width: 400px;
  padding: 16px 20px;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 10px;
  animation: slideIn 0.3s ease-out;
  background-color: ${({ type }) =>
    type === "success" ? SUCCESS_GREEN : type === "warning" ? WARNING_YELLOW : ERROR_RED};

  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  margin-left: auto;
  line-height: 1;
`;

const Notification = () => {
  const { message, type } = useSelector((state) => state.notification);
  const dispatch = useDispatch();

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        dispatch(dismissNotification());
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message, dispatch]);

  if (!message) return null;

  return (
    <ToastContainer type={type} role="alert" aria-live="assertive">
      <span>{message}</span>
      <CloseButton onClick={() => dispatch(dismissNotification())} aria-label="Dismiss notification">
        &times;
      </CloseButton>
    </ToastContainer>
  );
};

export default Notification;
